import { useMemo } from 'react';

import { useAccounts } from './useAccounts';

export function useTravelAccounts() {
  const accounts = useAccounts();
  return useMemo(
    () =>
      accounts.filter(
        account => account.closed === 0 && account.account_type === 'travel',
      ),
    [accounts],
  );
}
